module.exports = __webpack_public_path__ + "3f48cc3f2e6eeb7dfbcb97c5a9eac02b.svg";